import React from 'react';
import PropTypes from 'prop-types';
import ImageDisplay from './../../media/image/ImageDisplay';
import styles from './dragAndDropInteraction.scss';

class GapChoicePlaceholder extends React.PureComponent {
    static hasImage(gapChoiceModel) {
        const { mediaModel } = gapChoiceModel;
        return !!(mediaModel && mediaModel.type && mediaModel.type.includes('image'));
    }

    static hasText(gapChoiceModel) {
        return !!(gapChoiceModel.textContent && gapChoiceModel.textContent.length > 0);
    }

    static getDraggableNodeDimensions(geography) {
        return {
            height: `${geography.height}px`,
            width: `${geography.width}px`,
        };
    }

    static getRootElementStyle(gapChoiceModel) {
        if (!gapChoiceModel.geography || gapChoiceModel.type !== 'gapImg') {
            return undefined;
        }
        return GapChoicePlaceholder.getDraggableNodeDimensions(gapChoiceModel.geography);
    }

    render() {
        const { gapChoiceModel, mediaTracker } = this.props;
        const { mediaModel } = gapChoiceModel;
        const style = GapChoicePlaceholder.getRootElementStyle(gapChoiceModel);

        return (<div
            className={`${styles.gapChoicePlaceholder} ${gapChoiceModel.type} placeholder-${gapChoiceModel.identifier}`}
            ref={(element) => { this.rootElement = element; }}
            style={style}
        >
            {
                GapChoicePlaceholder.hasImage(gapChoiceModel)
                    ? <ImageDisplay
                        model={mediaModel}
                        reportReady={mediaTracker.addItemToTrack(`Media ${mediaModel.url || mediaModel.data || mediaModel.logicalName}`)}
                        autoScale
                    /> : null
            }
            {
                GapChoicePlaceholder.hasText(gapChoiceModel)
                    ? <div className={styles.textNode} dangerouslySetInnerHTML={{ __html: gapChoiceModel.textContent }} />
                    : null
            }
        </div>);
    }
}

GapChoicePlaceholder.propTypes = {
    gapChoiceModel: PropTypes.object.isRequired,
    mediaTracker: PropTypes.object.isRequired,
};

export default GapChoicePlaceholder;
